import { FocusSDK, getWebEnvObj, isFocusEnv } from "@/utils";
import Cookies from "js-cookie";
import { PageType, PageTypes } from "./const";
import { changeGovUrl, changeEgovUrl } from "@/utils/tools";
import { ErrorCode, FileType, IPageBase, ResetErrorCode } from "./types";
// import PageService from './service/PageService';
import JoyspaceController from "./controllers/JoyspaceController";
import {
  audio,
  excel,
  compressd,
  image,
  pdf,
  ppt,
  team_sheet,
  team_page,
  txt,
  unknown,
  video,
  word,
  program,
  gray_mind
} from "@/assets/images/joyspace";
import { folderTypeEnum } from "./config/permissions.config";

export const time = {
  format(isostr: Date | string | number | undefined) {
    if (isostr === undefined) {
      return "";
    }
    const date = new Date((isostr instanceof Date ? isostr : new Date(isostr)).getTime());
    const day = new Date();
    let time = "";
    if (day.toLocaleDateString() === date.toLocaleDateString()) {
      time = "今天 " + (isostr as any).slice(11, 16).replace(/\-/g, "/");
    } else if (isostr) {
      const isoary = (isostr as any).slice(0, 16).replace(/T| /g, "-").split("-");
      if (isoary.length < 4) {
        return time;
      }
      isoary[1] = isoary[1].replace(/\b(0+)/gi, "");
      isoary[2] = isoary[2].replace(/\b(0+)/gi, "");
      // @ts-ignore
      if (day.getYear() === date.getYear()) {
        return `${isoary[1]}月${isoary[2]}日 ${isoary[3]}`;
      } else {
        return `${isoary[0]}年${isoary[1]}月${isoary[2]}日  ${isoary[3]}`;
      }
    }
    return time;
  }
};

export const dateFormat = (ms: number) => {
  if (!ms) {
    console.error("ms is a null");
    return;
  } else if (typeof ms === "string") {
    return ms;
  }
  const date = new Date(ms);
  console.log(
    date,
    date.toLocaleDateString(),
    date.getHours(),
    date.getMinutes(),
    "dateFormat===>"
  );
  return `${date.toLocaleDateString()} ${date.getHours()}:${date.getMinutes()}`;
};

export const chineseTime = {
  format(isostr: Date | string | number | undefined, noMinAndSec?: boolean) {
    if (isostr === undefined) {
      return "";
    }
    const date = new Date(
      (isostr instanceof Date ? isostr : new Date(isostr)).getTime() + 60 * 60 * 1000 * 8
    );
    const today = new Date(new Date().toISOString().slice(0, 10));
    const tomorrow = new Date(today.getTime() + 86400000);
    let chineseTime = "";
    if (today < date && date < tomorrow) {
      chineseTime = "今天 " + date.toISOString().substr(11, 5);
    } else if (date.toISOString) {
      const minAndSec = !noMinAndSec ? date.toISOString().substr(11, 5) : "";
      chineseTime =
        date.toISOString().substr(0, 4).replace(/\-/g, "").replace("T", "") +
        "年" +
        date.toISOString().substr(5, 2).replace(/\-/g, "").replace("T", "") +
        "月" +
        date.toISOString().substr(8, 2).replace(/\-/g, "").replace("T", "") +
        "日 " +
        minAndSec;
    }
    return chineseTime;
  }
};

export function openLowCode(url?: string) {
  const { REACT_APP_JOYSPACE_LOWCODE_CREATE_URL } = process.env;
  // if (REACT_APP_JOYSPACE_LOWCODE_CREATE_URL) {
  //     window.open(url ?? REACT_APP_JOYSPACE_LOWCODE_CREATE_URL);
  // }
  window.open(url ?? REACT_APP_JOYSPACE_LOWCODE_CREATE_URL);
}

export function addToken(url: string) {
  const result =
    url +
    "?focus-token=" +
    (Cookies.get("focus-token") || "") +
    "&focus-team-id=" +
    (Cookies.get("focus-team-id") || "") +
    "&focus-app-id=" +
    (Cookies.get("focus-app-id") || "") +
    "&focus-client=web" +
    "&token=" +
    (Cookies.get("token") || "");
  return result;
}

export function isImageType(type: string) {
  if (!type || typeof type !== "string") {
    return false;
  }
  return type.match(/^image\/(gif|jpe?g|png|webp|bmp)/i);
}

export function getRnRouter(pageType: number) {
  switch (pageType) {
    case 1:
      return "document_edit";
    case 2:
      return "report_view";
    case 3:
      return "note_edit";
    case 4:
      return "spreadsheet_edit";
    case 5:
      return "";
    case 6:
      return "file_view";
    case 7:
      return "websheet_edit";
  }
}
export function isMySpace(pathname: string): boolean {
  if (pathname.includes("myspace")) {
    return true;
  }
  return false;
}
export function moveTips(from: any, to: any, isTeam: any): string {
  if (!isTeam && to.type === 8) {
    return "ctx.move.tips.no-change";
  }
  if (!isTeam && to.type === 12) {
    // 移动到共享成为根
    if (to.id === "teamRoot") {
      return "ctx.move.tips.no-change";
    }
    return "ctx.move.tips.my-to-share";
  }
  if (isTeam && to.type === 12) {
    // 权限不变时
    if (
      (from.space_id && (from.space_id === to.rootId || from.space_id === to.space_id)) ||
      (from.space_id === from.id && to.id === "teamRoot")
    ) {
      return "ctx.move.tips.no-change";
    }
    // 移动到共享成为根，取消所有权限
    if (to.id === "teamRoot") {
      return "ctx.move.tips.share-new";
    }
    // 权限改变时
    return "ctx.move.tips.share-change";
  }
  return "ctx.move.tips.no-change";
}

export function copyTips(from: any, to: any, isTeam: any): string {
  return "ctx.copy.tips.no-change";
}

export const userSelectDataType = {
  Group: "group",
  User: "user",
  Org: "org"
};

// 设置icon图片地址
export const setIconUrl = (data: any) => {
  let iconUrl = "";
  if (FocusSDK.getDeviceInfo().platform === "web") {
    let url = getWebEnvObj().REACT_APP_JOYSPACE_API_HOST;
    let { title, page_type: pageType, type } = data || {};
    title = title || "";
    pageType = pageType || "";
    type = type || "";
    iconUrl = `${url}/v1/common/icons?title=${encodeURIComponent(
      title
    )}&pageType=${pageType}&type=${type}&client=web`;
  } else {
    iconUrl = data.icon_url;
  }
  return iconUrl;
};
// 匹配joyspace Url 正则
export const legalJoyspaceUrlReg = (() => {
  // const singleDomainRegex = /[.a-z0-9]{3,}\/joyspace/;
  let authUrl = `${getWebEnvObj().REACT_APP_AUTH_HOST}/joyspace`;
  // const singleDomainRegex_1 = /joyspace\.?[.a-z0-9]{3,}|[.a-z0-9]{3,}\/joyspace/;
  const singleDomainRegex = new RegExp(authUrl);
  return {
    test: (arg: string) => {
      if (singleDomainRegex.test(arg)) {
        return true;
      }
      return false;
    }
  };
})();

// 匹配joyspace 单域名多域名 正则
export const legalJoyspaceUrlDomianReg = (() => {
  const multipleDomainRegex = /https?:\/\/((jzb-)?joyspace.*?\.jdcloud\.com|joyspace.*?\.jzb\.beijing\.e?gov\.cn)/;
  let authUrl = `${getWebEnvObj().REACT_APP_AUTH_HOST}/joyspace`;
  // const singleDomainRegex_1 = /joyspace\.?[.a-z0-9]{3,}|[.a-z0-9]{3,}\/joyspace/;
  const singleDomainRegex = new RegExp(authUrl);
  return {
    test: (arg: string) => {
      if (multipleDomainRegex.test(arg)) {
        return "multiple";
      }
      if (singleDomainRegex.test(arg)) {
        return "single";
      }
      return "";
    }
  };
})();
// 合法的joyspace 的地址，按理应该是通过项目的joyspace的baseurl去拼，但是因为需要兼容各环境暂时写死
export const checkJoyspaceUrl = (url: string) => {
  try {
    const isJoyspaceUrl = legalJoyspaceUrlDomianReg.test(url);
    if (isJoyspaceUrl) {
      const urlObj = new URL(url);
      const pathName = urlObj.pathname || "";
      const splits = pathName.split("/");
      let pageType;
      let fileId;
      if (isJoyspaceUrl === "multiple") {
        pageType = getPageTypes()[splits[1]] || "";
        fileId = splits[2] || "";
      } else {
        pageType = getPageTypes()[splits[2]] || "";
        fileId = splits[3] || "";
      }
      console.log("~~~", "pageType", pageType, "fileId", fileId);
      if (pageType && fileId) {
        return {
          is: true,
          pageType,
          webUrl: changeGovUrl(url),
          fileId
        };
      }
    }
    return { is: false, url: changeGovUrl(url) };
  } catch {}
  return { is: false, url: changeGovUrl(url) };
};
// 不仅匹配file、page、sheet等所有joyspace页面
// 合法的joyspace 的地址，按理应该是通过项目的joyspace的baseurl去拼，但是因为需要兼容各环境暂时写死
export const checkJoyspaceUrlAll = (url: string) => {
  try {
    const isJoyspaceUrl = legalJoyspaceUrlDomianReg.test(url);
    if (isJoyspaceUrl) {
      const urlObj = new URL(url);
      const pathName = urlObj.pathname || "";
      const splits = pathName.split("/");
      let pageType;
      let fileId;
      if (isJoyspaceUrl === "multiple") {
        pageType = getPageTypes()[splits[1]] || "";
        fileId = splits[2] || "";
      } else {
        pageType = getPageTypes()[splits[2]] || "";
        fileId = splits[3] || "";
      }
      console.log("~~~", "pageType", pageType, "fileId", fileId);
      if (pageType && fileId) {
        return {
          is: true,
          pageType,
          webUrl: changeEgovUrl(url),
          fileId
        };
      }
      return { is: true, url: changeEgovUrl(url) };
    }
    return { is: false, url: changeEgovUrl(url) };
  } catch {}
  return { is: false, url: changeEgovUrl(url) };
};
export async function openLink(page: IPageBase, urlPrefix: string, target = "_blank") {
  let url = createPageUrl(page, urlPrefix);
  FocusSDK.printLog("newWindowDebug: joyspace: 打开文档列表 before：", url);
  window.open && FocusSDK.printLog("joyspace: 打开文档文档列表 before has window.open：");

  try {
    if (page.isNew) {
      const { value } = await JoyspaceController.pageService.getFromDB(`base-data-${page.id}`);
      value.page.openTime = new Date().getTime();
      JoyspaceController.pageService.createPageInFile("apis", value.page);
      url = `${url}?isLocalCreate=1`;
    } else {
      // 离线新建的不上报
      joyaLog("d1", page.id, page.page_type, page.type, page.title);
    }
    // }
    setTimeout(() => {
      console.log(url, "url===>2");
      window.open(url, target);
    }, 1000);
  } catch (e) {
    console.log(e, "e=====>");
    FocusSDK.printLog("newWindowDebug: joyspace: 打开文档列表 error：", e);
  }
  FocusSDK.printLog("newWindowDebug: joyspace: 打开文档列表 end：", url);
}
const ServiceIdentification = "xtbg_joyspace_1000001";
export const joyaLog = (typeId: string, ...res: any) => {
  setTimeout(() => {
    // @ts-ignore
    const log = window.log || null;
    // console.log("joyaLog", log);
    if (!log) return;
    log(ServiceIdentification, typeId, ...res);
  }, 1000);
};
export function createPageUrl(page: IPageBase, urlPrefix: string) {
  if (Number(page.space_type) === 1 || Number(page.team_type) === 3) {
    return `${urlPrefix}/spaces/${page.id}`;
  }
  if (Number(page.type) === 13) {
    // 知识库
    return `${urlPrefix}/wiki/${page.id}`;
  }
  if (page.page_type === PageType.Form) {
    return page.link;
  }
  let DocType = "page";
  let pageType = page.page_type === PageType.Link ? page.origin?.page_type : page.page_type;
  const pageTypeTexts = getPageTypeTexts();
  if (pageTypeTexts.hasOwnProperty(pageType)) {
    DocType = pageTypeTexts[pageType];
  }
  return `${urlPrefix}/${DocType}/${page.id}`;
}
// image
export function imageFileMap() {
  return [
    "image/png",
    "image/gif",
    "image/jpeg",
    "image/jpg",
    "image/jpe",
    "image/webp",
    // 'image/jfif', --> image/jpeg
    // 'image/mdi' --> text/plain,
    "image/bmp",
    "image/tiff",
    // 'image/dwg', --> text/plain
    "image/x-icon",
    // 'image/pgm', --> text/plain
    // 'image/rgb', --> text/plain
    // 'image/psd', --> text/plain
    // 'image/cmx', --> text/plain"
    "image/tiff",
    // 'image/pcx', --> text/plain
    // 'image/eps', --> application/postscript
    "application/postscript"
  ];
}
// txt
export function txtFileMap() {
  return [
    "text/plain",
    "text/css",
    "text/py",
    "text/md",
    "text/jmx",
    "text/sql",
    "text/wpd",
    "text/odt",
    "text/pages",
    "text/json",
    "text/rtf",
    "text/key",
    "text/xmind",
    "text/xml",
    "text/uot",
    "text/uof",
    "text/uos",
    "text/uop",
    "text/ofd",
    "text/lwp",
    "text/java",
    "text/js",
    "text/log",
    "text/ini"
  ];
}
// video
export function videoFileMap() {
  return [
    "video/mp4",
    "video/quicktime",
    "video/webm",
    "video/ogg",
    "video/mp4v",
    "video/mov",
    "video/asx",
    "video/flv",
    "video/asf",
    "video/fil",
    "video/mpg",
    "video/wmv",
    "video/3gp",
    "video/webm",
    "video/mkv",
    "video/ogv",
    "video/avi",
    "video/webm",
    "video/vob",
    "video/3g2"
  ];
}
// audio
export function audioFileMap() {
  return [
    "audio/mpeg",
    "audio/mp3",
    "audio/x-mp3",
    "audio/x-mpg",
    "audio/x-mpeg-3",
    "audio/mpeg3",
    "audio/x-mpeg-3",
    "audio/x-flac",
    "audio/flac",
    "application/x-ape",
    "audio/x-ape",
    "audio/wav",
    "audio/x-wav",
    "audio/amr",
    "audio/opus",
    "audio/oga",
    "audio/ra",
    "audio/midi",
    "audio/m4a",
    "audio/flac",
    "audio/aiff",
    "audio/wma",
    "audio/caf",
    "audio/au",
    "audio/aac",
    "audio/sil",
    "audio/mid",
    "audio/ram",
    "audio/ogg",
    "audio/rmi"
  ];
}
// compressd
export function compressedFileMap() {
  return [
    "application/x-compressed",
    "application/x-rar-compressed",
    "multipart/x-zip",
    "application/vnd.rar",
    "application/zip",
    "application/x-7z-compressed",
    "application/x-zip-compressed",
    "application/rar",
    "application/7z",
    "application/bz2",
    "application/gz",
    "application/jar"
  ];
}
// program
export function programFileMap() {
  return [
    "application/dll",
    "application/exe",
    "multipart/msi",
    "application/com",
    "application/apk",
    "application/class",
    "application/rpm",
    "application/dep"
  ];
}
//  wps
export function wordFileMap() {
  return [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/eio-x-doc",
    "application/eio-x-docx",
    "application/wps-office.doc",
    "application/wps-office.docx"
  ];
}
// excle
export function excleFileMap() {
  return [
    "application/excel",
    "application/vnd.ms-excel",
    "application/x-excel",
    "application/x-msexcel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/eio-x-xls",
    "application/eio-x-xlsx",
    "application/wps-office.xls",
    "application/wps-office.xlsx"
  ];
}
// ppt
export function pptFileMap() {
  return [
    "application/vnd.ms-powerpoint",
    "application/mspowerpoint",
    "application/powerpoint",
    "application/x-mspowerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/eio-x-ppt",
    "application/eio-x-pptx",
    "application/wps-office.ppt",
    "application/wps-office.pptx"
  ];
}
// wps
export function wpsFileMap() {
  return [
    "application/wps-office.wps",
    "application/wps-office.dps",
    "application/wps-office.wpt",
    "application/wps-office.dpt",
    "application/wps-office.et",
    "application/wps-office.ett"
  ];
}
// pdf
export function pdfFileMap() {
  return [
    "application/pdf",
    "application/eio-x-pdf",
    "application/eio-x-pdfx",
    "application/wps-office.pdf",
    "application/wps-office.pdfx"
  ];
}
// audio, excel, exe, image, pdf, ppt, compressd, team_excel, team_page, txt, unknown, video, word

export function getIconUrl(type: any) {
  if (imageFileMap().includes(type)) {
    return image;
  }
  if (wordFileMap().includes(type)) {
    return word;
  }
  if (excleFileMap().includes(type) || wpsFileMap().includes(type)) {
    return excel;
  }
  if (pptFileMap().includes(type)) {
    return ppt;
  }
  if (pdfFileMap().includes(type)) {
    return pdf;
  }
  if (txtFileMap().includes(type)) {
    return txt;
  }
  if (videoFileMap().includes(type)) {
    return video;
  }
  if (audioFileMap().includes(type)) {
    return audio;
  }
  if (compressedFileMap().includes(type)) {
    return compressd;
  }
  if (programFileMap().includes(type)) {
    return program;
  }
  if (type === PageType.Page) {
    return team_page;
  }
  if (type === PageType.Sheet) {
    return team_sheet;
  }
  if (type === PageType.Mind) {
    return gray_mind;
  }
  return unknown;
}

/**
 * 局部刷新
 * item:更改之后的数据
 * data:要被更改数据
 * key: 根据 key去查询对应的要更改的数据
 * */

// eslint-disable-next-line max-params
export function partialRefresh(item: any, data: any[], key: any) {
  if (data instanceof Array) {
    let _data = [...data];
    const index = _data.findIndex((_item: any) => _item[key] === item[key]);
    if (index > -1) {
      if (item.oldPageId) {
        item.page_id = item.oldPageId;
      }
      _data.splice(index, 1, { ..._data[index], ...item });
    }
    // console.log(_data, '_data_data_data_data===>', item);
    return _data;
  }
  throw new Error("data必须为数组");
}

// 全局变量
let joyspaceDuccConfig: any = {};
let joyspaceAI = false;
// set joyspace下的ducc
export function setJoySpaceDucc(joyspaceDucc: any) {
  joyspaceDuccConfig = joyspaceDucc;
  // console.log(joyspaceDuccConfig, '===========================>');
}
export function setJoySpaceAI(injoyspaceAI: boolean) {
  joyspaceAI = injoyspaceAI;
}

export function getJoySpaceAI() {
  return joyspaceAI;
}

// get joyspace下的ducc
export function getJoySpaceDucc() {
  return joyspaceDuccConfig;
}

export function notUseJoySpaceOffline() {
  // 网页端关闭离线数据缓存
  return joyspaceDuccConfig.notUseOffline || !isFocusEnv() || false;
}

export function checkJoyspaceError(code: any) {
  if (code === ErrorCode.Delete || code === ResetErrorCode.Delete) {
    return true;
  }
  if (code === ErrorCode.noPermission || code === ResetErrorCode.noPermission) {
    return true;
  }
  return false;
}

export function getFullPathByForomId(fullPath = "") {
  let fromId = "";
  if (fullPath) {
    let ids = fullPath.split("$@$");
    fromId = ids[ids.length - 1];
  }
  if (fromId === "我的文件" || fromId === "共享文件") {
    return "";
  }
  return fromId;
}

// 获取文件所在的文件夹的路径
export function getFilePath(folderType: folderTypeEnum, fromId: string) {
  let path = "";
  if (folderType === folderTypeEnum.MY) {
    path = fromId ? `/joyspace/myspace?categoryId=${fromId}` : `/joyspace/myspace`;
  } else if (folderType === folderTypeEnum.SHARE) {
    path = fromId ? `/joyspace/teamspace?categoryId=${fromId}` : `/joyspace/teamspace`;
  }
  return path;
}

// 加载更多处理方法
export function handleLoadMore({ newList = [], oldList = [], total = 0 }) {
  let list: any = [...oldList];
  let isLoadMore = list.length < total;
  if (isLoadMore) {
    list = list.concat(newList);
    isLoadMore = list.length < total;
  }
  return { list, isLoadMore };
}

export const handleRootId = (id = "") => {
  if (!id) {
    console.error("id not null");
    return "";
  }
  if (id === "root") {
    return "myspace";
  } else if (id === "teamRoot") {
    return "teamspace";
  }
  return id;
};

export const getSpaceIdByRootId = (spaceId = "", rootId = "") => {
  const root = handleRootId(rootId);
  const space = handleRootId(spaceId);
  return space === root;
};

// 添加文件夹
export const createJoyspcFolderData = (type: FileType, info: any) => {
  if (!info) {
    console.error("info not null");
    return null;
  }
  if (type === FileType.Folder) {
    return { ...info, type: info.folder_type || info.spaceType || info.folderType };
  }
  const { full_name, full_path } = info;
  if (type === FileType.Page && full_path !== "/" && full_path.includes("$@$")) {
    const folderIds = full_path.split("$@$");
    const len = folderIds.length;
    const folderId = folderIds[len - 1];
    const names = full_name.split("$@$");
    const name = names[len - 1];
    names.splice(0, 1);
    folderIds.splice(0, 1);
    return {
      id: folderId,
      parent: "",
      space_id: folderId,
      full_path: folderIds.join("$@$"),
      full_name: names.join("$@$"),
      name,
      type: info.folder_type || info.spaceType || info.folderType
    };
  }
  return null;
};

const apis = [
  "joyspace.folder.sub",
  "joyspace.folder.update",
  "joyspace.folder.create",
  "joyspace.file.rename",
  "joyspace.file.presign",
  "joyspace.folder.rename",
  "joyspace.apply.approval",
  "joyspace.pageTransfer.create",
  "joyspace.batch.moveTo",
  "joyspace.folder.moveTo",
  "joyspace.pages.moveTo",
  "joyspace.share.allSharesMembers",
  "joyspace.pageApply.create",
  "joyspace.folder.batchCreate",
  "joyspace.folder.get",
  "joyspace.share.batchPrmission",
  "joyspace.share.batchRemove",
  "joyspace.share.create",
  "joyspace.sendlink.create",
  "joyspace.share.batchSetPermission",
  "joyspace.share.batchRemoveShare",
  "joyspace.permission.loginUser",
  "joyspace.file.ossUpload",
  "joyspace.pages.cloneResult",
  "joyspace.batch.copyTo",
  "joyspace.wps.startUploadTransaction",
  "joyspace.file.fileUploadinit",
  "joyspace.tag.create",
  "joyspace.tag.deleteRecords",
  "joyspace.tag.update",
  "joyspace.pages.listByTag"
];
export const hasJoyspaceApi = (api = "") => {
  if (!api) {
    return "api not null";
  }
  return apis.includes(api);
};

// 列表去重
export function removeDuplicate(arr: any[] = []) {
  const newArr: any[] = [];
  arr.forEach((item) => {
    const hasItem = newArr.some((newItem) => item.id === newItem.id);
    if (!hasItem) {
      newArr.push(item);
    }
  });
  return newArr; // 返回一个新数组
}
export function getJoyspaceDucc() {
  return (
    joyspaceDuccConfig.pageTypes || {
      page: {
        value: 1,
        routeTag: "document_edit"
      },
      sheet: {
        value: 4,
        routeTag: "spreadsheet_edit"
      },
      file: {
        value: 6,
        routeTag: "file_view"
      }
    }
  );
}
// "pageType": {
//   "page": 1, ....
// }
export function getPageTypes() {
  const pageTypes: any = getJoyspaceDucc();
  let tmpPageTypes: any = {};
  // eslint-disable-next-line guard-for-in
  for (let key in pageTypes) {
    tmpPageTypes[key] = pageTypes[key].value;
  }
  return tmpPageTypes;
}
// "pageType": {
//  "1": "page", ....
// }
export function getPageTypeTexts() {
  let pageTypeObj = getPageTypes();
  let invertedObj: any = {};
  // eslint-disable-next-line guard-for-in
  for (let key in pageTypeObj) {
    invertedObj[pageTypeObj[key]] = key;
  }
  return invertedObj;
}
export function canJoyspacePreview(name: string) {
  if (!name) return false;
  const ducc = getJoySpaceDucc();
  const {
    previewAllowSuffix = [
      "doc",
      "dot",
      "wps",
      "wpt",
      "docx",
      "dotx",
      "docm",
      "dotm",
      "xls",
      "xlt",
      "et",
      "xlsx",
      "xltx",
      "xlsm",
      "xltm",
      "ppt",
      "pptx",
      "pptm",
      "ppsx",
      "ppsm",
      "pps",
      "potx",
      "potm",
      "dpt",
      "dps",
      "pdf",
      "csv",
      "ett"
    ],
    canJoyspacePreview = true
  } = ducc;
  if (!canJoyspacePreview) {
    return false;
  }
  const result = previewAllowSuffix.find((item: string) => {
    return new RegExp(`.${item}$`).test(name.toLocaleLowerCase());
  });
  console.log("canJoyspacePreview", name, !!result);
  return !!result;
}
export function openJoyspacePreview(config: {
  host: string;
  code: string;
  isShowHeader?: number | boolean;
  canSaveToJoyspace?: number | boolean;
  canEdit?: number | boolean;
  gid?: string;
  gname?: string;
  canDownload?: number | boolean;
  canForward?: number | boolean;
}) {
  const {
    host,
    code,
    isShowHeader = 1,
    canSaveToJoyspace,
    gid,
    gname,
    canDownload = 1,
    canEdit,
    canForward = 1
  } = config;
  let url = `${host}/preview/${code}?`;
  if (!isShowHeader) {
    url = url + "&isShowHeader=0";
  }
  if (canSaveToJoyspace) {
    url = url + "&canSaveToJoyspace=1";
  }
  if (canEdit) {
    url = url + "&canEdit=1";
  }
  if (gid) {
    url = url + "&gid=" + gid;
  }
  if (gname) {
    url = url + "&gname=" + encodeURIComponent(gname);
  }
  if (!canDownload) {
    url = url + "&canDownload=0";
  }
  if (!canForward) {
    url = url + "&canForward=0";
  } else {
    url = url + "&canForward=1";
  }
  window.open(url);
}

export const previewAllowSuffix = [
  ".doc",
  ".docx",
  ".dot",
  ".dotx",
  ".wps",
  ".wpt",
  ".docm",
  ".dotm",
  ".txt"
];
export const isSupprotAbstract = (data: any) => {
  const pageType = data.page_type || data.pageType;
  if (pageType === 1) return true;
  if (pageType === 2) return false;
  const name = data.title || "";
  const result = previewAllowSuffix.find((item: string) => {
    return new RegExp(`.${item}$`).test(name.toLocaleLowerCase());
  });
  return result;
};

export const JoyspaceRouterMap: Record<string, string> = {
  home: "/joyspace/home",
  myspace: "/joyspace/myspace",
  teamspace: "/joyspace/teamspace",
  teamRoot: "/joyspace/teamspace",
  mytags: "/joyspace/mytags",
  knowledge: "/joyspace/wiki",
  collections: "/joyspace/collections",
  trashes: "/joyspace/trashes"
};
